import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail, FiUser, FiArrowRight, FiGift } = FiIcons;

const EmailCapture = ({ onSubmit, targetType }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    targetName: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="min-h-screen flex items-center justify-center p-6"
    >
      <div className="max-w-lg w-full">
        <motion.div
          initial={{ scale: 0.95 }}
          animate={{ scale: 1 }}
          className="bg-brand-floral rounded-2xl shadow-xl p-8 border border-brand-dust"
        >
          {/* Header */}
          <div className="text-center mb-8">
            <motion.div
              animate={{ bounce: [0, -10, 0] }}
              transition={{ duration: 2, repeat: Infinity }}
              className="w-16 h-16 bg-brand-crimson rounded-full flex items-center justify-center mx-auto mb-4"
            >
              <SafeIcon icon={FiGift} className="text-brand-floral text-3xl" />
            </motion.div>
            <h2 className="text-2xl font-bold text-brand-coffee mb-2 font-luxe">
              Get Your Personalized Report
            </h2>
            <p className="text-brand-coffee/80">
              Enter your details to receive your comprehensive brain profile analysis
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-brand-coffee mb-2">
                Your Name
              </label>
              <div className="relative">
                <SafeIcon icon={FiUser} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-brand-coffee/50" />
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full pl-10 pr-4 py-3 border border-brand-dust bg-transparent rounded-xl focus:ring-2 focus:ring-brand-crimson focus:border-transparent transition-all duration-300 outline-none"
                  placeholder="Enter your name"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-brand-coffee mb-2">
                Email Address
              </label>
              <div className="relative">
                <SafeIcon icon={FiMail} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-brand-coffee/50" />
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full pl-10 pr-4 py-3 border border-brand-dust bg-transparent rounded-xl focus:ring-2 focus:ring-brand-crimson focus:border-transparent transition-all duration-300 outline-none"
                  placeholder="Enter your email"
                />
              </div>
            </div>

            {targetType === 'other' && (
              <div>
                <label className="block text-sm font-medium text-brand-coffee mb-2">
                  Name of Person Assessed
                </label>
                <div className="relative">
                  <SafeIcon icon={FiUser} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-brand-coffee/50" />
                  <input
                    type="text"
                    name="targetName"
                    value={formData.targetName}
                    onChange={handleChange}
                    required
                    className="w-full pl-10 pr-4 py-3 border border-brand-dust bg-transparent rounded-xl focus:ring-2 focus:ring-brand-crimson focus:border-transparent transition-all duration-300 outline-none"
                    placeholder="Enter their name"
                  />
                </div>
              </div>
            )}

            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              type="submit"
              className="w-full flex items-center justify-center px-6 py-4 bg-brand-crimson text-brand-floral font-semibold rounded-xl shadow-lg hover:bg-brand-midnight transition-colors duration-300"
            >
              Generate My Report
              <SafeIcon icon={FiArrowRight} className="ml-2 text-xl" />
            </motion.button>
          </form>

          {/* Privacy Note */}
          <p className="text-xs text-brand-coffee/60 text-center mt-4">
            Your information is secure and will only be used to provide your assessment results and relevant updates.
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default EmailCapture;